export default __webpack_public_path__ + "static/media/products-list-images.3e5a4721.png";